// ---------------------------------------------------------------------------
// Where are we actually running?
//
// The Tesla center screen is a touch-only, ~1200x800 landscape display viewed
// from two to three feet away, often through glare, sometimes while the car is
// moving. Width-based breakpoints alone get this wrong: 1200px reads as
// "desktop" and we hand the car a four-column grid of laptop-sized text.
//
// Nothing here is load-bearing for correctness - a wrong guess only changes
// which layout we offer first, and the user's explicit choice always wins.
// ---------------------------------------------------------------------------

const KEY = "tm3_car_mode";

export function isCoarsePointer() {
  try {
    return typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia("(pointer: coarse)").matches
      : false;
  } catch (e) {
    return false;
  }
}

// Tesla's browser advertises itself on current builds; older center-screen
// builds do not, so fall back to a shape match (touch-only + the center
// display's characteristic landscape geometry).
export function isTeslaBrowser() {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/tesla/i.test(ua)) return true;
  if (!isCoarsePointer()) return false;
  const s = window.screen || {};
  const w = s.width || window.innerWidth || 0;
  const h = s.height || window.innerHeight || 0;
  const long = Math.max(w, h);
  const short = Math.min(w, h);
  return long >= 1150 && long <= 1320 && short >= 680 && short <= 860;
}

// "on" | "off" | null (never asked / never chosen)
export function carModePreference() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "on" || v === "off" ? v : null;
  } catch (e) {
    return null;
  }
}

export function setCarModePreference(v) {
  try {
    if (v === null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, v);
  } catch (e) {
    /* private mode - the preference just does not persist */
  }
}

// An explicit choice always beats detection.
export function shouldUseCarMode() {
  const pref = carModePreference();
  if (pref) return pref === "on";
  return isTeslaBrowser();
}
